import {AsyncPipe} from '@angular/common';
import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {MatTooltip} from '@angular/material/tooltip';
import {Asset} from '@app/asset';
import {AppState, StateService} from '@app/state/state.service';
import {UploadData, UploadItem, UploadService} from '@app/upload/upload.service';

import {Observable} from 'rxjs';

@Component({
    selector: 'frog-upload-button',
    templateUrl: './upload-button.component.html',
    styleUrls: ['./upload-button.component.scss'],
    imports: [MatButton, MatTooltip, MatIcon, AsyncPipe],
})
export class UploadButtonComponent implements OnInit {
    @Input() parentAsset: Asset;
    @ViewChild('file') file: ElementRef;

    public state$: Observable<AppState>;

    constructor(
        private stateService: StateService,
        private uploadService: UploadService,
    ) {}

    ngOnInit(): void {
        this.state$ = this.stateService.state;
    }

    browseFiles() {
        this.file.nativeElement.click();
    }

    onFilesAdded(streamId: string) {
        const uploadData = new UploadData(streamId);
        uploadData.uploadItems = Array.from(this.file.nativeElement.files).map(
            (item: File) => new UploadItem(item),
        );

        if (this.parentAsset) {
            uploadData.parentAssetId = this.parentAsset.id;
        }

        this.uploadService.showUploadDialog();
        this.uploadService.upload(uploadData).subscribe(() => {
            const fileElement = this.file.nativeElement as HTMLInputElement;
            fileElement.files = null;
        });
    }
}
